const BaseMixin = {
  /*mounted() {
        document.addEventListener('keydown', this.eventExcute);
    },
    beforeDestroy() {
        document.removeEventListener('keydown', this.eventExcute);
    },*/
  created() {
    document.addEventListener("keydown", this.invalid);
    document.addEventListener("keyup", this.eventExcute);
  },
  beforeDestroy() {
    document.removeEventListener("keydown", this.invalid);
    document.removeEventListener("keyup", this.eventExcute);
  },
  methods: {
    isScanSerial(storerkey,sku){
      return this.http.post('/isScanSerial',{storerkey,sku})
    },
    getOptions(url) {
      let optionsObject = [];
      let promise = this.selectAjax(url);
      promise.then((res) => {
        if (res.length > 0) {
          res.forEach((item) => {
            optionsObject.push(item);
          });
        }
      });
      return optionsObject;
    },
    selectAjax: function(url) {
      return new Promise((resolve, reject) => {
        this.http
          .get(url)
          .then((res) => {
            if (res.status == 200) {
              if (res.data.list) {
                resolve(res.data.list);
              } else {
                resolve(res.data);
              }
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    eventExcute(e) {
      let data = this.screen(e.keyCode);
      if (data && this[data[0]]) {
        if (data.length > 1) {
          this[data[0]](data[1]);
        } else {
          this[data[0]]();
        }
      }
    },
    invalid(e) {
      if(e&&e.code){
        const invalidList = ["f1", "f2", "f3", "f4", "f6", "f8", "f9"];
        const inv = invalidList.indexOf(e.code.toLowerCase());
        if (-1 !== inv) {
          e.preventDefault();
        }
      }
    },
    /*eventExcute: function (e) {
            /!*const invalidList = ['f1', 'f2', 'f3', 'f4', 'f5', 'f6', 'f8', 'f9'];
            if (e.code.toLowerCase()) {
                const inv = invalidList.indexOf(e.code.toLowerCase());
                if (-1 !== inv) {
                    e.preventDefault()
                }
            }*!/
            console.log(e);
            console.log(e.keyCode);
            let data = this.screen(e.keyCode);
            if (data && this[data[0]]) {
                if (data.length > 1) {
                    this[data[0]](data[1]);
                } else {
                    this[data[0]]();
                }
            }
        },*/
    screen(e) {
      switch (e) {
        case 13:
          return ["enter"];
        case 38:
          return ["arrowup"];
        case 40:
          return ["arrowdown"];
        case 48:
          return ["digit0", "0"];
        case 49:
          return ["digit1", "1"];
        case 50:
          return ["digit2", "2"];
        case 51:
          return ["digit3", "3"];
        case 52:
          return ["digit4", "4"];
        case 53:
          return ["digit5", "5"];
        case 54:
          return ["digit6", "6"];
        case 55:
          return ["digit7", "7"];
        case 56:
          return ["digit8", "8"];
        case 57:
          return ["digit9", "9"];
        case 112:
          return ["f1"];
        case 113:
          return ["f2"];
        case 114:
          return ["f3"];
        case 115:
          return ["f4"];
        case 116:
          return ["f5"];
        case 117:
          return ["f6"];
        case 119:
          return ["f8"];
        case 120:
          return ["f9"];
      }
    },
    //enter:function(){},
    //escape: function() {},
    //digit0: function() {},
    //digit1: function() {},
    //digit2: function() {},
    //digit3: function() {},
    //digit4: function() {},
    //digit5: function() {},
    //digit6: function() {},
    //digit7: function() {},
    //digit8: function() {},
    //digit9: function() {},
    //arrowup: function() {},
    //arrowdown: function() {}
    //f2:function(){}
    //f6:function(){}
  },
};
export default BaseMixin;
